<footer class="small text-center text-white-50 mt-2">
  <span data-test="app-version">{{ version }}</span> &copy; Disney
  <span data-test="app-year">{{ currentYear }}</span>
</footer>
